import ks from "../ReUsableTS/kBrowserShared";
import { AsKTimeOrNull, kHTMLEditableColType } from "./kEditableTableTypes";
import { kEditableTableRow } from "./kEditableTableRow";
import { kEditableTableHeading } from "./kEditableTableHeading";
import LNG from "../ReUsableTS/kLNG";
import type { kEditableTable } from "./kEditableTable";
import type { kObject, kObjectArray } from "../ReUsableTS/kBrowserObjects";
import type { kEditableTableCell } from "./kEditableTableCell";
import type { kEditableColumn } from "./kEditableColumn";

// Member bodies of kEditableTable moved here verbatim (this -> Self) by the size split of 2026-10-20; every kEditableTable member keeps its signature and delegates here.
export class kEditableTableRender {
    public static RemoveContentRows(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return ; }
        try {
            for (const CurrRow of Self.Rows.Items) {
                if (CurrRow.Row) { CurrRow.Row.remove(); }
            }
            Self.Rows.Items = [];
            Self.Selection.ClearPrev();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.RemoveContentRows");
            return;
        }
    }

    // public ContentToCollection = (ItemObject:any,ArrayObject?:any): any => {
    //     if (ks.KErrorMode === true) { return; }
    //     try {
    //         let CollectionItem: kObject = new ItemObject();;
    //         let CurrRow: kEditableTableRow;
    //         let CurrCell: kEditableTableCell;
    //         let RowIndex: number = 0;
    //         //this.ClearSelection();
    //         if (this.CurrenEditableCell) {
    //             this.CurrenEditableCell.SetCellReadMode();
    //         }
    //         if (this.RowValues === null) {
    //             if (ArrayObject) {
    //                 this.RowValues = new ArrayObject();
    //             } else {
    //                 this.RowValues = new kObjectArray()
    //             }
    //         }
    //         if (this.RowValues) {
    //             for (CurrRow of this.Rows.Items) {
    //                 if(CurrRow.IsEmppty() === false){
    //                     CollectionItem = this.RowValues.GetItemByUniqueID(CurrRow.UniqueID);
    //                     if (CollectionItem) {
    //                         CollectionItem.Index = RowIndex;
    //                     } else {
    //                         //New items added
    //                         CollectionItem = new ItemObject();
    //                         this.RowValues.push(CollectionItem);
    //                         CurrRow.UniqueID = CollectionItem.UniqueID;
    //                     }
    //                         for (CurrCell of CurrRow.Cells) {
    //                             if (CurrCell.ColDef) {
    //                                 switch (CurrCell.ColDef.Type) {
    //                                     case kHTMLEditableColType.Checkbox:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = CurrCell.Cell.textContent === "☑";
    //                                         break;
    //                                     case kHTMLEditableColType.Radio:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = CurrCell.Cell.textContent === "⚫";
    //                                         break;
    //                                     case kHTMLEditableColType.Color:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = CurrCell.Cell.style.backgroundColor;
    //                                         break;
    //                                     case kHTMLEditableColType.Date:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = CurrCell.CurrentValue;
    //                                         break;
    //                                     case kHTMLEditableColType.Number:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = ks.N0(CurrCell.CurrentValue);
    //                                     case kHTMLEditableColType.Currency:
    //                                         CollectionItem[CurrCell.ColDef.KObjectPropertyName] = ks.NumberFromCurrency(CurrCell.CurrentValue);
    //                                         break;
    //                                     default:
    //                                         if (CurrCell.Cell.textContent) {
    //                                             CollectionItem[CurrCell.ColDef.KObjectPropertyName] = CurrCell.Cell.textContent.trim();
    //                                         } else {
    //                                             CollectionItem[CurrCell.ColDef.KObjectPropertyName] = "";
    //                                         }
    //                                 }
    //                             }
    //                         }
    //                         RowIndex++;
    //                         //Existing items will be updated in the collection
    //                 }
    //             }
    //             for (CollectionItem of this.RowValues.Items) {
    //                 CurrRow = this.Rows.GetItemByUniqueID(CollectionItem.UniqueID);
    //                 if (CurrRow === null) {
    //                     this.RowValues.RemoveItemByUniqueID(CollectionItem.UniqueID);
    //                 }
    //             }
    //         }
    //         return this.RowValues;
    //     } catch (e) {
    //         ks.KGlobalErrorHandler(e, "kEditableTable.ContentToCollection");
    //         return;
    //     }
    // }
    public static GetGridContentsTokObjectArray(Self: kEditableTable, NewItemObject:any, NewArrayObject:any): any {
        if (ks.KErrorMode === true) { return new NewArrayObject(); }
        try {
            const ResultArray:kObjectArray = new NewArrayObject();
            Self["_ReconcileActiveEditForHarvest"]();
            for(const CurrRow of Self.Rows.Items){
                if(CurrRow.IsEmpty() === false){
                    const NewItem:kObject = new NewItemObject(CurrRow.GetValueFromCell("Title"));
                    ResultArray.push(NewItem);
                    for(const CurrCell of CurrRow.Cells){
                        if (CurrCell.ColDef) {
                            (NewItem as any)[CurrCell.ColDef.KObjectPropertyName] = Self["_ConvertCellValue"](CurrCell, CurrCell.ColDef);
                        }
                    }
                }
            }
            return ResultArray;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.GetGridContentsTokObjectArray");
            return new NewArrayObject();
        }
    }

    // Before harvesting the grid, reconcile any ACTIVE inline edit WITHOUT tearing
    // it down. When a consumer harvests on a debounced CellDirtiedCB, a stale 300ms
    // timer from a PRIOR commit can fire while the user is mid-typing the next cell;
    // an unconditional SetCellReadMode then flipped contentEditable off + committed +
    // grew a row under the live caret, so the character just typed appeared then
    // vanished (Risk-wizard "type a letter, it goes away", 2026-07-03). For a live
    // inline Text/Number/Currency cell, sync CurrentValue from the DOM (so IsEmpty
    // keeps the row and it serialises) WITHOUT ending the edit; every other cell
    // keeps the commit-on-harvest behaviour. Extracted from
    // GetGridContentsTokObjectArray to keep it within the 40-line limit.
    public static _ReconcileActiveEditForHarvest(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return; }
        try {
            if (Self.CurrenEditableCell) {
                const EditCell: kEditableTableCell = Self.CurrenEditableCell;
                if (EditCell.ColDef.CustomEditor === null
                    && EditCell.Cell.contentEditable === "true"
                    && (EditCell.ColDef.Type === kHTMLEditableColType.Text
                        || EditCell.ColDef.Type === kHTMLEditableColType.Number
                        || EditCell.ColDef.Type === kHTMLEditableColType.Currency)) {
                    EditCell.SyncInlineValueForHarvest();
                } else {
                    EditCell.SetCellReadMode();
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender._ReconcileActiveEditForHarvest");
        }
    }

    // Public: commit the cell the user is STILL editing into its CurrentValue, WITHOUT tearing down a
    // live Text/Number/Currency edit (so a harvest triggered mid-typing — a debounced CellDirtiedCB, or a
    // Save/OK button OUTSIDE the grid that never blurs the cell — keeps the last-typed character). A
    // consumer that harvests the grid ITSELF (iterating Rows.Items + GetValueFromCell, rather than the
    // built-in GetGridContentsTokObjectArray which already reconciles) MUST call this first, or the
    // actively-edited cell reads its STALE CurrentValue and the just-typed value is silently dropped.
    public static CommitActiveEdit(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return; }
        try {
            Self["_ReconcileActiveEditForHarvest"]();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.CommitActiveEdit");
        }
    }

    public static _ConvertCellValue(Self: kEditableTable, CurrCell: kEditableTableCell, ColDef: kEditableColumn): any {
        if (ks.KErrorMode === true) { return ""; }
        try {
            // Columns with a CustomRenderer own their cell content — typically
            // structured payloads (people chips, link objects) painted as
            // opaque elements. textContent.trim() would flatten them to a
            // display string and destroy the round-trip on harvest, so hand
            // the column's authoritative CurrentValue back instead.
            if (ColDef.CustomRenderer !== null) {
                return CurrCell.CurrentValue;
            }
            return Self["_ConvertByColType"](CurrCell, ColDef);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender._ConvertCellValue");
            return "";
        }
    }

    // Type-directed harvest conversion for a plain (non-CustomRenderer) cell.
    // Split out of _ConvertCellValue so each method owns one concern (the
    // CustomRenderer ownership decision vs. the per-type value conversion).
    public static _ConvertByColType(Self: kEditableTable, CurrCell: kEditableTableCell, ColDef: kEditableColumn): any {
        if (ks.KErrorMode === true) { return ""; }
        try {
            switch (ColDef.Type) {
                case kHTMLEditableColType.Checkbox:
                    return CurrCell.CurrentValue === true;
                case kHTMLEditableColType.Radio:
                    return CurrCell.CurrentValue === true;
                case kHTMLEditableColType.Color:
                case kHTMLEditableColType.Select:
                case kHTMLEditableColType.SelectMulti:
                    // Swatch/chip cells: value lives in CurrentValue, not the DOM
                    // (chips drop the "; " separators; the swatch has no background).
                    return ks.Nz(CurrCell.CurrentValue);
                case kHTMLEditableColType.Date:
                    // Normalise to kTime | null via the shared AsKTimeOrNull guard.
                    // A never-edited Date cell carries the cell-default empty string
                    // in CurrentValue; returning that as-is lets a downstream
                    // (M.DueDate === null ? null : M.DueDate.ToISODate()) pattern throw
                    // on the "" branch, corrupting the entire row serialisation.
                    return AsKTimeOrNull(CurrCell.CurrentValue);
                case kHTMLEditableColType.Number:
                case kHTMLEditableColType.Currency:
                    return ks.N0(CurrCell.CurrentValue);
                case kHTMLEditableColType.RichHtml:
                    // Raw HTML string — the default branch's textContent.trim()
                    // would strip all markup on harvest.
                    return ks.Nz(CurrCell.CurrentValue);
                default:
                    if (CurrCell.Cell.textContent) {
                        return CurrCell.Cell.textContent.trim();
                    }
                    return "";
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender._ConvertByColType");
            return "";
        }
    }

    public static AddContentRows(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return; }
        try {
            let CurrRowIndex: number = 0;
            let CurrItem: kObject;
            Self.Rows.Items = [];
            if (Self.RowValues && Self.Table) {
                for (CurrItem of Self.RowValues.Items) {
                    const NewRow: kEditableTableRow = Self["_CreateContentRow"](CurrItem, CurrRowIndex);
                    if (NewRow.Row) { Self.Table.appendChild(NewRow.Row); }
                    Self.Rows.push(NewRow);
                    CurrRowIndex++;
                }
            }
            if (Self.BlankRowsAllowed() === true) {
                Self.AddEmptyRows(1);
            }
            Self.ApplyAlternateRowShading();
            // Keep the page window / pager labels correct after a bulk row
            // rebuild (no-op unless a filter is active or pagination is on).
            Self._ReapplyIfFiltering();
            // Rows now carry their values — (re)paint Number/Currency data-bars
            // here (the canonical rebuild point) so a sample-data reload that
            // bypasses ToTable still gets them.
            Self.ApplyDataBars();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.AddContentRows");
            return;
        }
    }

    /** Moved from kEditableTable._CreateContentRow (size split); the class member delegates here. */
    public static _CreateContentRow(Self: kEditableTable, CurrItem: kObject, CurrRowIndex: number): kEditableTableRow {
        if (ks.KErrorMode === true) { return new kEditableTableRow(CurrRowIndex); }
        try {
            const NewRow: kEditableTableRow = new kEditableTableRow(CurrRowIndex);
            NewRow.UniqueID = CurrItem.UniqueID;
            NewRow.ID = CurrItem.ID;
            NewRow.ParentTable = Self;
            // WHOLE-TABLE READ-ONLY reaches the row here, at the one place rows are born, so it
            // cannot be honoured for the first render and forgotten on a rebuild. Rows are what the
            // delete / remove / fill / paste gates actually test — see ReadOnly.
            if (Self.ReadOnly === true) { NewRow.SetReadOnly(true); }
            let CurrColIndex: number = 0;
            let CurrCol: kEditableColumn;
            for (CurrCol of Self.Columns.Items) {
                NewRow.AddCell(Self["_CreateContentCell"](CurrItem, CurrCol, CurrRowIndex, CurrColIndex));
                CurrColIndex++;
            }
            return NewRow;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender._CreateContentRow");
            return new kEditableTableRow(CurrRowIndex);
        }
    }

    /** Moved from kEditableTable._PaintGridRole (size split); the class member delegates here. */
    public static _PaintGridRole(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return; }
        try {
            Self.Table.setAttribute("role", "grid");
            if (Self.AriaLabel !== "") { Self.Table.setAttribute("aria-label", Self.AriaLabel); }
            // THE grid's one tab stop (2026-10-14). Until then the <table> had no tabindex, so the
            // keyboard could reach the grid only through links and icons painted inside it.
            Self.Table.tabIndex = 0;
            Self.Table.addEventListener("focus", Self.OnTableFocus);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender._PaintGridRole");
        }
    }

    public static ToTable(Self: kEditableTable): HTMLTableElement {
        if (ks.KErrorMode === true) { return document.createElement("table"); }
        try {
            Self.AddStyles();
            Self.SetupRowContextMenu();
            Self.SetupColContextMenu();
            Self.SetupRangeContextMenu();
            Self.SetupCornerContextMenu();
            Self.Table = document.createElement("table");
            Self.Table.className = "kEditableTable";
            Self["_PaintGridRole"]();
            Self["_PaintReadOnlyMode"]();
            const RowNumberHeading:kEditableTableHeading = new kEditableTableHeading("",false,null);
            if(RowNumberHeading && RowNumberHeading.HeaderCell){
                RowNumberHeading.Sortable = false;
                RowNumberHeading.HeaderCell.setAttribute("role", "columnheader");
                Self.Table.appendChild(RowNumberHeading.HeaderCell);
                RowNumberHeading.HeaderCell.style.borderRight = "thin solid grey";
                RowNumberHeading.HeaderCell.addEventListener("click",Self.Selection.SelectAll);
                RowNumberHeading.HeaderCell.style.cursor = "context-menu";
                RowNumberHeading.HeaderCell.title = LNG.EXPORTTOEXCEL;
                if(Self.CornerContextMenu){
                    RowNumberHeading.HeaderCell.addEventListener("contextmenu",Self.CornerContextMenu.ShowMenu);
                }
            }
            Self["_CreateColumnHeaders"]();
            if(Self.RowValues){
                Self.AddContentRows();
            }else{
                Self.AddEmptyRows(10);
            }
            document.addEventListener("keydown", Self.KeyDown);
            Self.Table.addEventListener("paste", Self.PasteHandler);
            Self.Table.addEventListener("mouseenter", Self.MouseEnter);
            return Self.Table;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.ToTable");
            return document.createElement("table");
        }
    }

    // Repaint the faint magnitude data-bars for every Number/Currency column,
    // each scaled to that column's own max. Called once after the grid renders and
    // again after a Number/Currency edit commits. Pagination shows/hides existing
    // rows (it does not rebuild cells), so a single pass survives page changes.
    public static ApplyDataBars(Self: kEditableTable): void {
        if (ks.KErrorMode === true) { return; }
        try {
            let ColIndex: number = 0;
            let CurrCol: kEditableColumn;
            if (Self.ShowDataBars === false) { return; }
            for (CurrCol of Self.Columns.Items) {
                if (CurrCol.ShowDataBar === false) { ColIndex = ColIndex + 1; continue; }
                if (CurrCol.Type === kHTMLEditableColType.Number || CurrCol.Type === kHTMLEditableColType.Currency) {
                    Self.ApplyColumnDataBars(ColIndex);
                }
                ColIndex = ColIndex + 1;
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.ApplyDataBars");
        }
    }

    // Repaint the data-bars for one Number/Currency column: find the column's max
    // absolute value across ALL rows, then scale each cell's bar to it.
    public static ApplyColumnDataBars(Self: kEditableTable, ColumnIndex: number): void {
        if (ks.KErrorMode === true) { return; }
        try {
            let ColumnMax: number = 0;
            let CurrRow: kEditableTableRow;
            let CurrCell: kEditableTableCell;
            let CurrVal: number;
            const Col: kEditableColumn = Self.Columns.Items[ColumnIndex];
            const Enabled: boolean = Self.ShowDataBars !== false && (Col === undefined || Col.ShowDataBar !== false);
            // Off: ColumnMax stays 0, so the paint pass below CLEARS any bar already drawn.
            for (CurrRow of Self.Rows.Items) {
                if (Enabled === false) { break; }
                CurrCell = CurrRow.Cells[ColumnIndex];
                if (CurrCell) {
                    CurrVal = Math.abs(ks.N0(CurrCell.CurrentValue));
                    if (CurrVal > ColumnMax) { ColumnMax = CurrVal; }
                }
            }
            for (CurrRow of Self.Rows.Items) {
                CurrCell = CurrRow.Cells[ColumnIndex];
                if (CurrCell) { CurrCell._PaintDataBar(ColumnMax); }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableRender.ApplyColumnDataBars");
        }
    }
}
